module.exports = "<div class=\"page\">\r\n    <div class=\"page-content p-2\">\r\n        <br/>\r\n        <br/>\r\n        <br/>\r\n        <p><img style=\"display: block; margin-left: auto; margin-right: auto;\" src=\"assets/img/logo-white.png\" alt=\"\" width=\"219\" height=\"81\" /></p>\r\n        <p style=\"text-align: center;\"><strong>Gracias por Terminar tu registro, en breve nos pondremos en contacto contigo</strong></p>\r\n        <br/>\r\n        <br/>\r\n        <br/>\r\n    </div>\r\n</div>\r\n\r\n\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/page/termino-registro-page/termino-registro-page.component.html
// module id = 1161
// module chunks = 0